export const env = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT,
  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
  GOOGLE_SCOPES: process.env.REACT_APP_GOOGLE_SCOPES,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  QUICKBOOKS_CLIENT_ID: process.env.REACT_APP_QUICKBOOKS_CLIENT_ID,
  QUICKBOOKS_REDIRECT_URI: process.env.REACT_APP_QUICKBOOKS_REDIRECT_URI,
  QUICKBOOKS_SCOPE: process.env.REACT_APP_QUICKBOOKS_SCOPE,
  QUICKBOOKS_AUTH_URL: process.env.REACT_APP_QUICKBOOKS_AUTH_URL,
  WHITELISTED_DOMAINS: process.env.REACT_APP_WHITELISTED_DOMAINS,
  SHOPIFY_APP_URL: process.env.REACT_APP_SHOPIFY_APP_URL,
  COOKIES_DOMAIN: process.env.REACT_APP_COOKIES_DOMAIN,
  REACT_APP_SUPER_ADMIN: process.env.REACT_APP_SUPER_ADMIN,  
  SENTRY_ENABLED: process.env.REACT_APP_SENTRY_ENABLED,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SENTRY_ENVIRONMENT: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  SENTRY_TRACES_SAMPLE_RATE: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE: process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
};
